const constants = {
  communicationsHistory: {
    'auto-call': 'Робозвонок',
    'smart-ivr': 'Голосовой бот',
    ticket: 'Тикет',
    autofaq: 'Автофак',
    push: 'Push',
    sms: 'SMS',
    email: 'Email',
  },
  locale: {
    ru: 'Русский',
    uk: 'Украинский',
    en: 'Английский',
    es: 'Испанский',
    it: 'Итальянский',
    de: 'Немецкий',
    fr: 'Французский',
    ko: 'Корейский',
    ja: 'Японский',
    pl: 'Польский',
    pt: 'Португальский',
    tr: 'Турецкий',
    ar: 'Арабский',
  },
  serviceLocale: {
    ru: 'Русский',
    uk: 'Украинский',
    en: 'Английский',
    es: 'Испанский',
    it: 'Итальянский',
    de: 'Немецкий',
    fr: 'Французский',
    ko: 'Корейский',
    ja: 'Японский',
    pl: 'Польский',
    pt: 'Португальский',
    tr: 'Турецкий',
    ar: 'Арабский',
  },
  brand: {
    none: 'Без бренда',
    osmi: 'Osmi',
  },
};

export default constants;
